import { createContext, useContext } from 'react'

export const INACTIVE_REGISTRATION_INVITE = {
  isValid: false,
  token: null,
  firstName: '',
  lastName: '',
  email: '',
}

export const RegistrationInviteContext = createContext(
  INACTIVE_REGISTRATION_INVITE,
)

export const useRegistrationInvite = () => useContext(RegistrationInviteContext)
